import CreatorProfilePicture from './container'
export { CreatorProfilePicture }
export default CreatorProfilePicture